import examples from "data/examples.json";
import { EntryDashboard } from "lib/entries/types";
import { EntryPage } from "lib/entries/types";
import { Session } from "lib/users/types";
import { fetchDashboard } from "lib/entries/entries";
import { isDashboard } from "lib/entries/entries";
import { logger } from "lib/logger/browser";

export const fetchExampleDashboards = async (
  session?: Session
): Promise<EntryPage<EntryDashboard>> => {
  const res = await Promise.all(
    examples.dashboards.map((path) => {
      const [user, slug] = path.split("/");

      return fetchDashboard(user, slug, session).catch((err) => {
        logger.warn(err);
        return undefined;
      });
    })
  );

  return {
    count: res.length,
    page: 1,
    page_size: res.length,
    results: res.filter(isDashboard),
  };
};
